// extracted by mini-css-extract-plugin
export default {"Container":"AddressBadge_Container__kiiGZ"};